import { Box, Button, Typography } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import { FocusBuildingsList } from './FocusBuildingsList'
import { type AnnualPlanRole } from '../../../../../../models/AnnualPlanRole'

interface Props {
  priorityId: number
  planOrgId: number
  isdOrgId: number
  userRole: AnnualPlanRole | null
  readOnly: boolean
  trackingReadonly: boolean
  onBack: () => void
  implementationPhase: boolean
}

export const FocusBuildings = (props: Props): JSX.Element => {
  return <Box data-testid="focusBuildings" sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  }}
  >
    <Button
      data-testid="backPdrsButton"
      onClick={props.onBack}
      sx={{
        padding: '5px 10px',
        backgroundColor: 'var(--grey-50)',
        color: 'var(--grey-500)',
        width: 'fit-content'
      }}
    >
      <ArrowBack sx={{ mr: '10px' }} />
      Peer to Peer Programs
    </Button>

    <Typography variant='h1'>Focus Buildings</Typography>
    <Typography variant='body1'>
      Developing new programs or expanding programs can include many activities such as starting a new Peer to Peer program in a building, using resources and fidelity tools to strengthen a program, formalizing an existing program, offering trainings about Peer to Peer, or collecting data about the impact of Peer to Peer on students and staff. List the buildings where Peer to Peer will be established or enhanced, resources needed, and the budget request to accomplish identified actions. Click “Things to Consider” for additional information.
    </Typography>

    <FocusBuildingsList
      priorityId={props.priorityId}
      planOrgId={props.planOrgId}
      isdOrgId={props.isdOrgId}
      userRole={props.userRole}
      readOnly={props.readOnly}
      trackingReadonly={props.trackingReadonly}
      implementationPhase={props.implementationPhase}
    />
  </Box>
}
